import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

export function loadTipsSuccess(tips) {
    return {type: types.LOAD_TIPS_SUCCESS, tips};
}

export function createTipSuccess(tip) {
    return {type: types.CREATE_TIP_SUCCESS, tip};
}

export function getTipSuccess(tip) {
    return {type: types.GET_TIP_SUCCESS, tip};
}

export function updateTipSuccess(tip) {
    return {type: types.UPDATE_TIP_SUCCESS, tip};
}

export function deleteTipSuccess(id) {
    return {type: types.DELETE_TIP_SUCCESS, id};
}

export function cloneTipSuccess(tip) {
    return {type: types.CLONE_TIP_SUCCESS, tip};
}

export function resetTip() {
    return { type: types.RESET_TIP };
}

export function getTip(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('tips', id).then(tip => {
            dispatch(getTipSuccess(tip))
        }).catch(error => {
            throw error;
        });
    }
}

export function loadTips(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all('tips?page='+page, sortParams).then(tips => {
            dispatch(loadTipsSuccess(tips))
        }).catch(error => {
            throw error;
        });
    }
}

export function saveTip(tip) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('tips', tip).then(tip => {
            dispatch(createTipSuccess(tip));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateTip(tip, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('tips', id, tip).then(tip => {
            dispatch(updateTipSuccess(tip));
        }).catch(error => {
            throw error;
        })
    }
}

export function deleteTip(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('tips', id).then(() => {
            dispatch(deleteTipSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function cloneTip(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('tips/clone', id).then(tip => {
            dispatch(cloneTipSuccess(tip))
        }).catch(error => {
            throw  error;
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/tipsActions.js